import React, { useRef } from 'react';
import { Box, Typography, TablePagination, IconButton, Button } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import BondTable from '../BondTable';
import BondDetailsModal from '../BondDetails/BondDetailsModal';
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import { tokens } from '../../Common/designTokens'; // added token import

const AccountPositionsTable = ({ 
  data, 
  selectedColumns,
  allColumns, // Use this prop
  onCustomizeColumns, // Use this prop
  loading, 
  sortConfig,
  onSort,
  page,
  itemsPerPage,
  totalElements,
  onPageChange,
  onRowsPerPageChange,
  onCusipClick,
  onEditPositions,             // NEW
  disableEditPositions = false // NEW
}) => {
  // Add ref for customize button
  const customizeButtonRef = useRef(null);
  
  const handleRowClick = (rowIndex, rowData) => {
    // Mock implementation for row click
    console.log('Clicked row:', rowIndex, rowData);
  };

  const handleViewJson = (rowData) => {
    // Mock implementation for viewing JSON
    console.log('View JSON for:', rowData);
  };

  // Handle customize columns button click
  const handleCustomizeClick = (event) => {
    if (onCustomizeColumns) {
      onCustomizeColumns(event.currentTarget);
    }
  };

  // Don't paginate data here since it's already paginated from the server
  const displayData = data;

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column',
        height: 'calc(100vh - 360px)',
      }}>
        {/* Header */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          px: 2,
          py: 1,
          borderBottom: `1px solid ${tokens.colors.bodyBorderColor50}`, // token-based border
          flexShrink: 0
        }}>
          <Typography variant="h6" sx={{ color: tokens.colors.fontColour, fontWeight: 'bold' }}> {/* token color */}
            Portfolio Holdings
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}> {/* NEW wrap for two buttons */}
            <Button
              variant="contained"
              color="inherit"
              startIcon={<TuneIcon />} // reuse icon style
              sx={{ 
                height: 42, 
                textTransform: "none", 
                borderRadius: "8px",
                backgroundColor: 'transparent',
                color: tokens.colors.fontColour,
                '&:hover': { backgroundColor: tokens.colors.defaultGridHoverColor }
              }}
              onClick={onEditPositions}
              disabled={disableEditPositions}
            >
              Add/Edit Positions
            </Button>
            <Button
              ref={customizeButtonRef}
              variant="contained"
              color="inherit"
              startIcon={<ViewColumnOutlinedIcon />} // icon uses primary token
              sx={{ 
                height: 42, 
                textTransform: "none", 
                borderRadius: "8px", // <-- changed from 0
                backgroundColor: 'transparent',
                color: tokens.colors.fontColour,
                '&:hover': { backgroundColor: tokens.colors.defaultGridHoverColor }
              }}
              onClick={handleCustomizeClick}
            >
              Columns
            </Button>
          </Box>
          {/* Customize Columns Button */}
          {/* <IconButton 
            ref={customizeButtonRef}
            onClick={handleCustomizeClick}
            sx={{ 
              color: 'rgba(255, 255, 255, 0.7)',
              '&:hover': {
                color: 'rgba(245, 166, 35, 1)',
                backgroundColor: 'rgba(255, 255, 255, 0.05)'
              }
            }}
            title="Customize Columns"
          >
            <TuneIcon />
          </IconButton> */}
        </Box>
        
        {/* Table content */}
        <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
          <BondTable
            selectedColumns={selectedColumns}
            filteredData={displayData}
            handleRowClick={handleRowClick}
            handleViewJson={handleViewJson}
            sectionKey="account-positions"
            source="account-positions"
            onSort={onSort}
            sortConfig={sortConfig}
            loading={loading}
            handleCusipClick={onCusipClick} // Pass handler to BondTable
          />
        </Box>
      </Box>
      
      {/* Pagination */}
      <Box
        sx={{
          position: "fixed",
          bottom: 10,
          left: -25,
          width: "100%",
          color: tokens.colors.fontColour, // token-based text color
          zIndex: 1000,
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <TablePagination
          component="footer"
          sx={{
            ".MuiSelect-select": { p: "4px 24px 5px 8px !important" },
            color: tokens.colors.fontColour
          }}
          showFirstButton
          showLastButton
          rowsPerPage={itemsPerPage}
          rowsPerPageOptions={[20, 50, 100]}
          page={page}
          onRowsPerPageChange={onRowsPerPageChange}
          onPageChange={onPageChange}
          count={totalElements}
          labelDisplayedRows={({ from, to, count }) => `${from.toLocaleString()}–${to.toLocaleString()} of ${count.toLocaleString()}`}
        />
      </Box>
       
    </>
  );
};

export default AccountPositionsTable;
